module.exports = __webpack_public_path__ + "670812089eb04c4260422f57121050fc.svg";